import { set } from 'idb-keyval';

import { SET_COMPANY, UPDATE_CURRENT_COMPANY } from '../../actionTypes';
import { debugAction } from '../../utils';

export const company = {
  data: {
    current: {},
    all: []
  }
};

export function companyReducer(state = company, action) {
  debugAction(action);
  switch (action?.type) {
    case SET_COMPANY:
      set('currentCompany', action?.payload?.[0]);
      return { data: { current: action?.payload?.[0], all: action?.payload } };
    case UPDATE_CURRENT_COMPANY:
      set('currentCompany', action?.payload);
      return { data: { ...state.data, current: action?.payload } };
    default:
      return { ...state };
  }
}
